import {
  
    UPDATE_ACTIVITY,

} from "constants/ActionTypes";

const INIT_STATE = {
    activityId: -1,
    isUpdate: false,
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UPDATE_ACTIVITY: {
            return {
                ...state,
                activityId: action.payload.activityId,
                isUpdate: action.payload.isUpdate
            }
        }
        default:
            return state;
    }
}
